import { Editor, Transforms } from "slate";

const withSingleLine = (editor: Editor) => {
  const { insertData, insertText, normalizeNode } = editor;

  // Ensure the editor always has exactly one block-level element.
  editor.normalizeNode = (entry) => {
    const [, path] = entry;
    if (path.length === 0) {
      if (editor.children.length > 1) {
        Transforms.mergeNodes(editor);
      }
    }
    normalizeNode(entry);
  };

  // When pasting, only insert the plain text content.
  editor.insertData = (data: DataTransfer) => {
    const text = data.getData("text/plain");
    if (text) {
      editor.insertText(text);
    } else {
      insertData(data);
    }
  };

  // Prevent new lines from being inserted by converting them to spaces
  editor.insertText = (text) => {
    insertText(text.replace(/(\r\n|\n|\r)/gm, " "));
  };

  return editor;
};

export default withSingleLine;
